import { render, staticRenderFns } from "./removeSewer.vue?vue&type=template&id=15a319a1"
import script from "./removeSewer.ts?vue&type=script&lang=js&external"
export * from "./removeSewer.ts?vue&type=script&lang=js&external"
import style0 from "./removeSewer.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports